import React from "react";
import { ReactComponent as WupLogoSvg } from "./assets/wup_logo.svg";

export const WupLogo = (): JSX.Element => <WupLogoSvg />;
